import React from "react";
import ListInventoryBody from "../../inventory/list/ListInventoryBody";
import { HistoryTable } from "../../../@types/subscripton";

interface SubscriptionHistoryProps {
  history: HistoryTable[];
  isLoading: boolean;
}

const SubscriptionHistory = ({
  history,
  isLoading,
}: SubscriptionHistoryProps) => {
  const [data, setData] = React.useState<typeof history>([]);

  React.useEffect(() => {
    setData(history);
  }, [history]);

  const tableHead = [
    {
      dataIndex: "plan",
      title: "Plan",
    },
    {
      dataIndex: "startDate",
      title: " Start date",
    },
    {
      dataIndex: "endDate",
      title: "End date",
    },
    {
      dataIndex: "costPerMonth",
      title: "Amount",
    },
    {
      dataIndex: "status",
      title: "Status",
    },
  ];

  return (
    <div>
      <ListInventoryBody
        data={data}
        tableHead={tableHead}
        isLoading={isLoading}
        showPagination
      />
    </div>
  );
};

export default SubscriptionHistory;
